import { render } from "./TemaKlimatilpasning.vue?vue&type=template&id=215b19ca&scoped=true"
import script from "./TemaKlimatilpasning.vue?vue&type=script&lang=js"
export * from "./TemaKlimatilpasning.vue?vue&type=script&lang=js"

import "./TemaKlimatilpasning.vue?vue&type=style&index=0&id=215b19ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215b19ca"]])

export default __exports__